"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./WirelessCommonCart.scss");
var cartUtils = require("../../../utils/CartUtilFunctions");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var LobTitle_1 = require("../../CommonCart/common/LobTitle");
var WirelessCommonCart = /** @class */ (function (_super) {
    __extends(WirelessCommonCart, _super);
    function WirelessCommonCart(props) {
        var _this = _super.call(this, props) || this;
        _this.showTitle = _this.showTitle.bind(_this);
        _this.showLineItem = _this.showLineItem.bind(_this);
        _this.showDueAmount = _this.showDueAmount.bind(_this);
        return _this;
    }
    WirelessCommonCart.prototype.render = function () {
        var payload = cartUtils.getWirelessCart();
        this.losgList = Object.values(payload.wirelessCart.losgs).sort(wlsUtils.sortLogs);
        return (React.createElement("div", null,
            this.showTitle(),
            this.showLineItem(),
            this.showDueAmount()));
    };
    WirelessCommonCart.prototype.showTitle = function () {
        return (React.createElement("div", null,
            React.createElement(LobTitle_1.default, { testId: "Wireless", data: { show: true, lineOfBusinessName: 'Wireless', planType: 'wireless' }, events: {} })));
    };
    WirelessCommonCart.prototype.showLineItem = function () {
        return (React.createElement("div", null,
            React.createElement("span", null, ":::::::::::: Line Items section :::::::::::::::"),
            this.losgList.map(function (losg) {
                var isMixAndMatch = false;
                var lineItems = wlsUtils.organizeLineItems(Object.values(losg.lineItems), isMixAndMatch);
                return (lineItems.map(function (lineItem, index) {
                    return (React.createElement("div", { key: "lineItemInfo" + index }, lineItem.displayName));
                }));
            })));
    };
    WirelessCommonCart.prototype.showDueAmount = function () {
        return (React.createElement("div", null, " :::::::::::: Due Today & Due Monthely ::::::::::::::: "));
    };
    return WirelessCommonCart;
}(React.Component));
exports.default = WirelessCommonCart;
//# sourceMappingURL=WirelessCommonCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/WirelessCommonCart/WirelessCommonCart.js
// module id = 2367
// module chunks = 8